module.exports = __webpack_public_path__ + "img/NJCBCNBNXXX.df1bd59e.png";